import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import FAIcon from "../UI/FAIcon/FAIcon";
const PrimarySidebarItem = (props) => {
    const location = useLocation();
    return (_jsx("div", { className: "p-sidebar-item " +
            ((location === null || location === void 0 ? void 0 : location.pathname.includes(props.to)) ? "active" : ""), children: _jsx(Link, { className: "p-sidebar-item-title", to: props.to, children: _jsxs("button", { className: "btn btn-link", title: props.title, tabIndex: -1, children: [_jsx(FAIcon, { icon: props.icon, addMarginRight: true, fixedWidth: true, className: "mr-2 fa-fw" }), _jsx("span", { className: "p-sidebar-hide-on-close", children: props.title })] }) }) }));
};
export default PrimarySidebarItem;
